// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { AutomationsInput, PaginationInput } from '@/gql/graphql';

const automationKeys = {
  all: ['automation'] as const,
  automations: (variables?: {
    input?: AutomationsInput;
    pagination?: PaginationInput;
  }) => {
    if (!variables) {
      return [...automationKeys.all, 'list'] as const;
    }

    return [...automationKeys.all, 'list', variables] as const;
  },
};

export default automationKeys;
